import React from 'react';

const Forum = () => {
  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h1>Forum</h1>
      <p>Coming Soon</p>
    </div>
  );
};

export default Forum;
